import { isTokenExpirationValid } from '@juristai/shared/src/utils/tokenExpiration';

export const hasValidStoredSession = (authState) => {
  const storedIsAuthenticated =
    authState?.isAuthenticated ?? localStorage.getItem('isAuthenticated') === 'true';
  const storedAccessToken = authState?.access ?? localStorage.getItem('access');
  const storedAccessExpiration =
    authState?.access_expiration ?? localStorage.getItem('access_expiration');
  const hasAccessToken =
    typeof storedAccessToken === 'string' && storedAccessToken.trim().length > 0;
  const isTokenValid = hasAccessToken && isTokenExpirationValid(storedAccessExpiration);

  return storedIsAuthenticated === true && isTokenValid;
};
